var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4 fill-height grid-container"},[_c('h1',[_vm._v(_vm._s(_vm.pageTitle))]),_c('div',{staticClass:"body"},[_c('CommandsList',{staticClass:"body-content",attrs:{"commands":_vm.enrichedCommands}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }